import "swiper/swiper.min.css";
import "video.js/dist/video-js.min.css";
import "../shared-assets/styles/styles.scss";
// import "../shared-assets/styles/components";
import Head from "next/head";
import ReactGA from "react-ga4";
import "swiper/css/pagination";
import { AppContextProvider } from "../app/services/app-context-services";
import { NotifContextProvider } from "../app/services/notif-context-services";
import { useScrollRestoration } from "../app/services/scroll-restoration-hook";


export default function App({ Component, pageProps, router }) {
  useScrollRestoration(router);
  const branch = process.env.NEXT_PUBLIC_APP_BRANCH;
  // if (isEnvironment("production")) {
  ReactGA.initialize('G-VG1M0SFHDS');
  // }

  return (
    <NotifContextProvider>
      <AppContextProvider>
        <>
          <Head>
            <base href="/" />
            <meta charSet="utf-8" />
            <meta name="viewport" content="initial-scale=1, maximum-scale=6" />
            <meta name="robots" content={(branch === "test" || branch === "beta") ? "noindex, nofollow" : "index"} />
            <link rel="icon" type="image/x-icon" href="favicon.ico" />
            <link rel="shortcut icon" href="./favicon.ico" />
            <link rel="manifest" href="/manifest.json" />
          </Head>
          <Component {...pageProps} />
        </>
      </AppContextProvider>
    </NotifContextProvider>
  );
}